export const userAccountTypeToRouteType = {
  'admin': 'admin',
  'manager': 'manager',
  'super_consultant': 'super_consultant',
  'consultant': 'consultant',
  'customer': 'customer',
  'accountant': 'accountant'
};
const marketUrlParts = ['/uk/', '/be/', '/de/'];
const routesExcludedFromThisRedirect = ['/login', '/login_failed'];
export const redirectUserToAnotherAccountTypeRouteIfNecessary = (user, history) => {
  const {
    href,
    pathname
  } = window.location;
  const matchingMarketUrlPart = marketUrlParts.find(marketUrlPart => href.includes(marketUrlPart));
  const loggedInAndOnMarketUrl = !!user?.id && !!matchingMarketUrlPart;
  const pathNameEndsWithMarketPart = marketUrlParts.some(marketUrlPart => [pathname, pathname + '/'].includes(marketUrlPart));
  const pathnameEndsWithExcludedRoute = routesExcludedFromThisRedirect.some(route => pathname.endsWith(route));
  if (!matchingMarketUrlPart || pathNameEndsWithMarketPart || pathnameEndsWithExcludedRoute) {
    // not handled from here - there is another redirect elsewhere
    return;
  }
  const notLoggedInAndOnMarketUrl = !user?.id && !!matchingMarketUrlPart;

  // There is another /login redirect in the app - but for some reason it does not capture cases where we are at
  // http://localhost/uk/claim_groups/13/technical_uploads?group_projects=false
  // and we are not logged in.
  // Notice the fact that the url above does not contain parts like /client/, /manager/, etc.
  if (notLoggedInAndOnMarketUrl) {
    const afterMarketUrlPart = href.split(matchingMarketUrlPart)[1];
    if (afterMarketUrlPart !== 'login') {
      const correctHref = href.replace(afterMarketUrlPart, 'login');
      window.location.href = correctHref;
      return;
    }
  }
  if (!loggedInAndOnMarketUrl) {
    return;
  }

  /**
   * Because the user is already logged in and we are on a specific market url, then
   * all urls the user goes to should include the user type - like so:
   * /uk/customer/...
   * 
   * If the href does not include the account type - that means that we may have sent an account agnostic url - e.g.
   * in an email. In that case we should automatically send the user to the correct url.
   * 
   * In case the url contains an account type part - but it does not match the correct account type part for the
   * logged in user, we should redirect the user to the correct page for them.
   */

  // we need to use pathname here, so that we remove the query ?foo=bar
  // otherwise afterMarketUrlPart can become "customer?foo=bar"
  // This way it is simply "customer".
  // "customer/somepage" works fine, because we split by "/"
  const afterMarketUrlPart = pathname.split(matchingMarketUrlPart)[1];
  const firstUrlPart = afterMarketUrlPart.split('/')[0];
  const accountTypePart = Object.values(userAccountTypeToRouteType).find(accountTypePart => accountTypePart === firstUrlPart);
  const correctUserAccountTypeUrlPart = userAccountTypeToRouteType[user.account_type];

  // account type is missing, which is wrong
  if (!accountTypePart) {
    const correctHref = href.replace(matchingMarketUrlPart, `${matchingMarketUrlPart}${correctUserAccountTypeUrlPart}/`);
    window.location.href = correctHref;
    return;
  }
  if (correctUserAccountTypeUrlPart === accountTypePart) {
    //
  } else {
    const correctHref = href.replace(accountTypePart, correctUserAccountTypeUrlPart);
    window.location.href = correctHref;
    return;
  }
  return true;
};